import { colors } from '../../colors';
var address = {
  addressColor: colors.metal
};
export default address;